<script>
import Layout from '@layouts/main'
import ShowGridBlock from '@components/show/show-grid-block'

export default {
    page() {
        const title = 'Your Shows'
        const description = 'Your Shows'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    components: { Layout, ShowGridBlock },
    data() {
        return {
            favPopulatedList: Array.from(Array(6), (e, i) => ({
                shows: {
                    id: Number.MAX_SAFE_INTEGER - i * 10,
                },
            })),
            shouldTransition: false,
            maxShows: 30,
            increaseShows: 15,
            shouldLoadMore: false,
            isLoading: false,
        }
    },
    computed: {
        favList() {
            return this.$store.state.favorites.showList
        },
        showList() {
            return this.favPopulatedList.map(el => el.shows)
        },
        scroll() {
            return this.$store.state.appearance.scroll
        },
        scrollChild() {
            return this.$store.state.appearance.scrollChild
        },
    },
    watch: {
        favList: {
            handler() {
                this.$dataLayer.favShows
                    .get(this.maxShows)
                    .then(({ body }) => {
                        this.favPopulatedList = body
                        this.shouldLoadMore = true
                        this.isLoading = false
                    })
                    .then(() => {
                        this.shouldTransition = true
                    })
                    .catch(() => {
                        this.isLoading = false
                    })
            },
            immediate: true,
        },
        scroll() {
            let bottomOfWindow =
                this.scroll + window.innerHeight >=
                this.$store.state.appearance.scrollChild.offsetHeight - window.innerHeight / 3

            if (bottomOfWindow && this.shouldLoadMore) {
                this.shouldLoadMore = false
                setTimeout(() => {
                    this.shouldLoadMore = true
                }, 200)
                this.loadMoreShows()
            }
        },
    },
    methods: {
        loadMoreShows() {
            this.maxShows += this.increaseShows
            this.$dataLayer.favShows.get(this.maxShows).then(({ body }) => {
                this.favPopulatedList = body
                this.shouldLoadMore = true
            })
        },
    },
}
</script>

<template>
    <Layout>
        <BaseContent title="Your Shows">
            <BaseSection padded>
                <ShowGridBlock
                    v-if="showList.length"
                    :shows="showList"
                />
                <BaseEmptyList
                    v-else
                    :error="{
                        title: `You are not following any shows.`,
                        paragraph: 'Following shows helps us recommend similar shows.',
                    }"
                />
            </BaseSection>
        </BaseContent>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';
</style>
